import { CouponInfo, MerchantInfo } from '../../../type';
import { PageResult } from '../types';
import { getCouponListByClassId, getCouponListBySPId as getCouponListBySP } from '../api';
import { resolveMerchantInfo } from './merchant';
import { mapCouponType } from '../../../business/coupon';
import { amount } from '@tencent/wphk-base-utils';
import { getValidCurrencyType } from '@tencent/wphk-act-base-ui';
/**
 * 解析券信息
 * @param data 券数据
 * @returns
 */
function resolveCouponInfo(data): CouponInfo | null {
  if (!data) {
    return null;
  }
  return {
    /** 商户id */
    spId: data.spid,
    /** 券ID */
    couponId: data.coupon_id || '',
    /** 展示券图片URL */
    goodsUrl: data.goods_url ? decodeURIComponent(data.goods_url) : '',
    /** 展示券名称 */
    couponName: data.coupon_name || '',
    /** 券的价值 */
    couponValue: parseAmountValue(data.coupon_value),
    /** 券的上架时间在一周内（T - 7） */
    isNew: !!data.is_new,
    /** 券可领开始时间 */
    startTime: data.start_time || '',
    /** 券可领结束时间 */
    endTime: data.end_time || '',
    /** 生效时间 */
    validTime: data.valid_time || '',
    /** 生效时间类型 */
    validType: parseInt(data.valid_type, 10) || 1,
    /** 相对生效天数 */
    validDay: parseInt(data.valid_nday, 10) || 0,
    /** 过期时间 */
    expireTime: data.expire_time || '',
    /** 过期时间类型 */
    expireType: parseInt(data.expire_type, 10) || 1,
    /** 过期相对天数 */
    expireDay: parseInt(data.expire_nday, 10) || 0,
    /** 所属商户信息 */
    merchantInfo: resolveMerchantInfo(data)!,
    /** 券状态 */
    state: +data.state,
    /** 券使用条件描述(展示才有) */
    couponCondition: data.coupon_condition || '',
    /** 用户券id，当券领取后可以展示，需注意未来变成多张券的情况，可能需要处理 */
    userScid: data.user_scid || '',

    /** 券类型 */
    type: mapCouponType(data.coupon_type),
    /** 核销金额(优惠券才有) */
    requireNum: amount.fen2Yuan(data.require_num || '0'),
    /** 适用商户 */
    couponRange: data.coupon_range,
    /** 币种类型 */
    currencyType: getValidCurrencyType(data.cur_type),
  };
}

/**
 * 转换金额，如果金额分转元后小数部分为0，则省去
 * @param value
 * @returns
 */
const parseAmountValue = (value: string) => {
  const val = amount.fen2Yuan(value) || '0';
  return val.endsWith('.00') ? val.replace(/\.0{2}$/, '') : val;
};

/**
 * 解析券信息
 * @param array
 * @returns
 */
export const resolveCouponInfoArray = (array: any[]) => array.map(item => resolveCouponInfo(item))
  .filter((item): item is CouponInfo => item !== null);

/**
 * 获取指定分类下的券列表信息
 * @param classId 分类ID
 * @returns
 */
export async function getListByClassId(classId: string, offset: number, limit: number):
Promise<PageResult<CouponInfo>> {
  const { hasNextPage, totalCount, dataList } = await getCouponListByClassId(classId, offset, limit);
  return {
    hasNextPage,
    totalCount,
    dataList: resolveCouponInfoArray(dataList),
  };
};

/**
 * @param spId 获取商户下的券列表信息
 * @param merchantInfo 商户基本信息
 * @param maxCount 获取券张数，默认获取所有券
 * @description 商户下券太多会导致接口查询报错，原因是返回报文太大超过了后端框架限定，所以需要分页多次查询
 * @returns
 */
export async function getCouponListBySPId(spId: string, merchantInfo: MerchantInfo, maxCount?: number) {
  const result: CouponInfo[] = [];
  const queryLimit = 10; // 线上有发现商户券超过14张查询可能会引发报错，这里设置一次查10张比较保险
  let pageNum = 0;
  let offset = 0;
  let isQueryMore = true;

  while (isQueryMore) {
    let limit = queryLimit;
    // 有个数限定情况下尝试只获取指定个数券，否则获取全部
    if (maxCount) {
      limit = Math.min(queryLimit, maxCount - result.length);
      if (limit <= 0) {
        break;
      }
    }
    offset = pageNum * limit;
    const { couponList, hasNextPage } = await getCouponListBySP(spId, offset, limit);
    const resolveList = resolveCouponInfoArray(couponList);
    result.push(...resolveList.map(item => ({ ...item, merchantInfo })));
    isQueryMore = hasNextPage;
    pageNum += 1;
  }
  return result;
}

/**
 * 领券
 * @param couponId 券ID
 * @returns
 */
export function execCoupon(couponId: string) {
  console.log(couponId);
  return true;
}

